import { api } from "../../lib/api";

const sha256 = async (buf) => Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", buf))).map((b) => b.toString(16).padStart(2, "0")).join("");
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Resumable chunked upload of a CSV/XLSX (up to 100 MB). Re-selecting the same file continues where it stopped.
export async function uploadSheet(file, onProgress) {
  const key = `mivo-sheet:${file.name}:${file.size}:${file.lastModified}`;
  let u = null;
  const saved = localStorage.getItem(key);
  if (saved) { try { u = (await api.get(`/sheet-uploads/${saved}`)).data; } catch (e) { u = null; } }
  if (!u) { u = (await api.post("/sheet-uploads", { file_name: file.name, size: file.size })).data; localStorage.setItem(key, u.upload_id); }
  if (u.status !== "ready") {
    const have = new Set(u.received);
    for (let n = 0; n < u.chunks; n += 1) {
      if (!have.has(n)) {
        const buf = await file.slice(n * u.chunk_size, Math.min(file.size, (n + 1) * u.chunk_size)).arrayBuffer();
        const h = await sha256(buf);
        for (let a = 0; ; a += 1) {
          try { await api.put(`/sheet-uploads/${u.upload_id}/chunks/${n}`, buf, { headers: { "Content-Type": "application/octet-stream", "X-Chunk-Sha256": h } }); break; } catch (e) {
            const st = e.response?.status;
            if (a >= 4 || (st && st < 500 && st !== 429)) throw e;
            await wait(1000 * 2 ** a);
          }
        }
      }
      onProgress?.((n + 1) / u.chunks);
    }
    u = (await api.post(`/sheet-uploads/${u.upload_id}/complete`)).data;
  }
  localStorage.removeItem(key);
  return u;
}
